/* tslint:disable */
/* eslint-disable */
/* @relayHash 8a37404676af26ea7952304f6ce781d8 */

import { ConcreteRequest } from "relay-runtime";
export type AdditionalCommentQueryVariables = {
    commentID: string;
};
export type AdditionalCommentQueryResponse = {
    readonly comment: {
        readonly id: string;
        readonly viewerActionPresence: {
            readonly illegal: boolean;
        } | null;
    } | null;
};
export type AdditionalCommentQuery = {
    readonly response: AdditionalCommentQueryResponse;
    readonly variables: AdditionalCommentQueryVariables;
};



/*
query AdditionalCommentQuery(
  $commentID: ID!
) {
  comment(id: $commentID) {
    id
    viewerActionPresence {
      illegal
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentID"
        } as any)
    ], v1 = [
        ({
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "commentID"
                }
            ],
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "comment",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "ActionPresence",
                    "kind": "LinkedField",
                    "name": "viewerActionPresence",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "illegal",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "AdditionalCommentQuery",
            "selections": (v1 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "AdditionalCommentQuery",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "id": "8a37404676af26ea7952304f6ce781d8",
            "metadata": {},
            "name": "AdditionalCommentQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = 'ad8562cb27850225c5b4251f781a41e8';
export default node;
